import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, DollarSign, Package, TrendingUp } from 'lucide-react';
import { Product } from '../../../types/Product';
import { calculateOverallStats } from '../../../utils/statistics/overview';
import { StatCard } from '../common/StatCard';

interface StatisticsOverviewProps {
  products: Product[];
}

export const StatisticsOverview: React.FC<StatisticsOverviewProps> = ({ products }) => {
  const stats = calculateOverallStats(products);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard
        title="Total Productos"
        value={stats.totalProducts}
        icon={<ShoppingCart className="text-orange-500" size={24} />}
        trend={stats.productTrend}
      />
      <StatCard
        title="Precio Promedio"
        value={`${stats.averagePrice.toFixed(2)}€`}
        icon={<DollarSign className="text-green-500" size={24} />}
        trend={stats.priceTrend}
      />
      <StatCard
        title="Categorías"
        value={stats.totalCategories}
        icon={<Package className="text-blue-500" size={24} />}
        trend={stats.categoryTrend}
      />
      <StatCard
        title="Tendencia General"
        value="Estable"
        icon={<TrendingUp className="text-purple-500" size={24} />}
      />
    </div>
  );
};